export const navLinks = [
  { label: '首页', href: '/' },
  { label: '电影', href: '/category/movie' },
  { label: '电视剧', href: '/category/tv' },
  { label: '综艺', href: '/category/variety' },
  { label: '动漫', href: '/category/anime' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '海量高清电影，随时随地畅享大片体验',
    color: 'accent',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热门剧集每日更新，追剧不等待',
    color: 'primary',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '欢乐综艺节目，放松身心好选择',
    color: 'secondary',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-ghost-smile-line',
    description: '经典与新番动漫，二次元世界触手可及',
    color: 'accent',
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '2024年度热播大剧',
    subtitle: '《长安十二时辰》全网热播，精彩不容错过',
    imageQuery: 'Ancient%20Chinese%20palace%20drama%20scene%20with%20warm%20golden%20lighting%2C%20traditional%20costumes%2C%20cinematic%20composition%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20rich%20dark%20tones%2C%20professional%20movie%20poster%20style%2C%20artistic%20rendering%20with%20deep%20shadows%20and%20warm%20highlights',
    link: '/category/tv',
    badge: '热播中',
  },
  {
    id: 2,
    title: '高分电影精选',
    subtitle: '豆瓣8.5分以上好片，品质观影首选',
    imageQuery: 'Cinematic%20movie%20collage%20with%20warm%20amber%20and%20gold%20tones%2C%20film%20reel%20elements%2C%20dramatic%20lighting%2C%20artistic%20movie%20poster%20aesthetic%2C%20dark%20cinematic%20background%20with%20soft%20glow%2C%20vintage%20film%20texture%2C%20professional%20cinema%20atmosphere',
    link: '/category/movie',
    badge: '高分推荐',
  },
  {
    id: 3,
    title: '热门综艺集结',
    subtitle: '欢笑与感动并存，精彩综艺尽在糖豆视频',
    imageQuery: 'Vibrant%20variety%20show%20stage%20with%20colorful%20warm%20lighting%2C%20entertainment%20atmosphere%2C%20modern%20studio%20setting%2C%20dynamic%20composition%2C%20golden%20and%20coral%20accent%20lights%2C%20professional%20broadcast%20style%2C%20lively%20and%20energetic%20mood',
    link: '/category/variety',
    badge: '每周更新',
  },
];

export const hotRecommendations = [
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    rating: 8.9,
    year: 2024,
    imageQuery: 'Futuristic%20sci-fi%20movie%20scene%20with%20giant%20planet%20and%20spaceship%2C%20dramatic%20warm%20orange%20and%20teal%20cinematic%20lighting%2C%20epic%20scale%2C%20movie%20poster%20style%2C%20clean%20background%2C%20professional%20cinematic%20rendering%2C%20atmospheric%20and%20grand',
    badge: '热播',
  },
  {
    id: 2,
    title: '狂飙',
    category: '电视剧',
    rating: 9.1,
    year: 2024,
    imageQuery: 'Chinese%20crime%20drama%20scene%20with%20intense%20atmosphere%2C%20dark%20urban%20setting%2C%20dramatic%20warm%20lighting%2C%20TV%20series%20poster%20style%2C%20professional%20photography%2C%20moody%20and%20suspenseful%2C%20clean%20composition',
    badge: '热播',
  },
  {
    id: 3,
    title: '奔跑吧第十季',
    category: '综艺',
    rating: 8.5,
    year: 2024,
    imageQuery: 'Variety%20show%20outdoor%20scene%20with%20bright%20sunlight%2C%20energetic%20group%20activity%2C%20colorful%20warm%20tones%2C%20cheerful%20atmosphere%2C%20professional%20broadcast%20photography%2C%20clean%20and%20vibrant%20composition',
    badge: '热播',
  },
  {
    id: 4,
    title: '庆余年第二季',
    category: '电视剧',
    rating: 9.3,
    year: 2024,
    imageQuery: 'Ancient%20Chinese%20costume%20drama%20with%20elegant%20palace%20setting%2C%20warm%20golden%20hour%20lighting%2C%20artistic%20composition%2C%20cinematic%20style%2C%20rich%20textures%2C%20professional%20TV%20series%20poster%20aesthetic',
    badge: '热播',
  },
  {
    id: 5,
    title: '封神第二部',
    category: '电影',
    rating: 8.7,
    year: 2024,
    imageQuery: 'Chinese%20mythology%20fantasy%20movie%20scene%20with%20epic%20battle%2C%20dramatic%20warm%20fire%20and%20gold%20lighting%2C%20cinematic%20scale%2C%20professional%20movie%20poster%20style%2C%20grand%20and%20atmospheric%2C%20clean%20background',
    badge: '新片',
  },
  {
    id: 6,
    title: '王牌对王牌第八季',
    category: '综艺',
    rating: 8.3,
    year: 2024,
    imageQuery: 'Studio%20variety%20show%20with%20colorful%20stage%20lighting%2C%20warm%20and%20vibrant%20atmosphere%2C%20entertainment%20setting%2C%20professional%20photography%2C%20cheerful%20mood%2C%20clean%20composition%2C%20bright%20coral%20and%20golden%20accents',
    badge: '更新',
  },
  {
    id: 7,
    title: '繁花',
    category: '电视剧',
    rating: 9.0,
    year: 2024,
    imageQuery: 'Shanghai%20nostalgic%20drama%20scene%20with%20warm%20vintage%20lighting%2C%20elegant%201990s%20aesthetic%2C%20cinematic%20composition%2C%20rich%20golden%20tones%2C%20professional%20TV%20series%20poster%2C%20atmospheric%20and%20stylish',
    badge: '高分',
  },
  {
    id: 8,
    title: '熊出没·逆转时空',
    category: '动漫',
    rating: 8.6,
    year: 2024,
    imageQuery: '3D%20animated%20family%20movie%20scene%20with%20forest%20setting%2C%20warm%20sunlight%2C%20cute%20bear%20characters%2C%20vibrant%20colors%2C%20cinematic%20animation%20style%2C%20cheerful%20and%20adventurous%20mood%2C%20clean%20composition',
    badge: '新片',
  },
];

export const latestUpdates = [
  {
    id: 1,
    title: '三体：大结局震撼上线，科幻迷不可错过',
    excerpt: '经过漫长的等待，备受瞩目的科幻巨制《三体》终于迎来大结局。本季以宏大的宇宙视角和深刻的人性探讨，为观众呈现了一场视觉与思想的双重盛宴...',
    category: '电视剧',
    date: '2024-12-28',
    imageQuery: 'Sci-fi%20cosmic%20scene%20with%20distant%20stars%20and%20galaxies%2C%20mysterious%20dark%20space%20background%2C%20warm%20golden%20nebula%20accents%2C%20cinematic%20scale%2C%20atmospheric%20and%20awe-inspiring%2C%20clean%20composition',
    readTime: '5分钟',
  },
  {
    id: 2,
    title: '2025春节档电影盘点：哪部值得看？',
    excerpt: '春节档作为全年最重要的电影档期之一，2025年春节档将有多部重量级影片上映。本文为您详细盘点即将上映的大片，帮您提前做好观影规划...',
    category: '电影',
    date: '2024-12-27',
    imageQuery: 'Chinese%20new%20year%20celebration%20with%20red%20lanterns%20and%20golden%20decorations%2C%20festive%20cinema%20atmosphere%2C%20warm%20lighting%2C%20movie%20theater%20setting%2C%20cheerful%20mood%2C%20clean%20and%20elegant%20composition',
    readTime: '8分钟',
  },
  {
    id: 3,
    title: '《繁花》为何成为年度现象级剧集？',
    excerpt: '由王家卫执导的《繁花》自播出以来，凭借独特的视觉风格和深刻的时代叙事，迅速成为现象级爆款。本文深度解析这部剧集的成功密码...',
    category: '电视剧',
    date: '2024-12-26',
    imageQuery: 'Shanghai%20night%20scene%20with%20neon%20lights%2C%20vintage%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20stylish%20urban%20atmosphere%2C%20professional%20photography%20style',
    readTime: '6分钟',
  },
  {
    id: 4,
    title: '国产动漫崛起：2024年度优秀国漫推荐',
    excerpt: '近年来国产动漫质量不断提升，涌现出越来越多优秀作品。2024年更是国漫大丰收的一年，本文为您精选年度最佳国漫作品...',
    category: '动漫',
    date: '2024-12-25',
    imageQuery: 'Chinese%20animation%20style%20artwork%20with%20vibrant%20colors%2C%20ink%20wash%20painting%20influence%2C%20dynamic%20composition%2C%20warm%20and%20rich%20tones%2C%20artistic%20rendering%2C%20modern%20anime%20aesthetic%2C%20clean%20background',
    readTime: '7分钟',
  },
];

export const features = [
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '采用先进的视频加速技术，确保观影过程流畅无卡顿，告别缓冲等待的烦恼。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '支持超高清视频播放，每一帧画面都清晰细腻，为您带来沉浸式观影体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持手机、平板、电脑等多设备无缝切换，随时随地想看就看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '严格的内容审核机制，为您提供绿色健康的观影环境，观影更放心。',
  },
];

export const stats = [
  { value: '5000+', label: '影视资源' },
  { value: '98%', label: '用户好评率' },
  { value: '1000万+', label: '活跃用户' },
  { value: '24h', label: '内容更新' },
];

export const aboutInfo = {
  brandName: '糖豆视频',
  slogan: '糖豆视频，甜蜜每一刻观影时光',
  introduction:
    '糖豆视频成立于2020年，是一家专注于高清免费影视内容导航的在线平台。我们致力于为用户提供最优质的影视内容发现服务，汇聚海量电影、电视剧、综艺、动漫资源，让每一位用户都能轻松找到自己喜爱的影视内容。',
  mission: '让优质影视内容触手可及',
  vision: '成为最受用户信赖的影视内容导航平台',
  values: ['用户至上', '内容为王', '技术驱动', '诚信为本'],
  contact: {
    email: 'contact@tangdou.com',
    phone: '400-888-9999',
    address: '北京市朝阳区光华路88号糖豆大厦',
    wechat: 'tangdoushipin',
  },
};

export const faqs = [
  {
    question: '糖豆视频需要下载APP吗？',
    answer: '不需要！糖豆视频是纯网页端平台，无需下载任何APP或插件，打开浏览器即可畅享高清影视内容。我们采用先进的Web技术，确保您在任何设备上都能获得流畅的观影体验。',
  },
  {
    question: '糖豆视频收费吗？',
    answer: '糖豆视频始终坚持免费原则，所有影视内容均可免费在线观看。我们通过广告和推荐服务维持平台运营，绝不会向用户收取任何观影费用。',
  },
  {
    question: '为什么有些视频无法播放？',
    answer: '如果您遇到视频无法播放的情况，可能是由于网络波动或来源链接临时失效导致。建议您尝试刷新页面或切换网络环境后重试。如问题持续存在，欢迎联系我们的客服团队。',
  },
  {
    question: '糖豆视频支持哪些设备？',
    answer: '糖豆视频全面支持PC、平板、手机等各类设备。无论在Windows、macOS、iOS还是Android系统上，只需使用现代浏览器即可流畅访问我们的平台。',
  },
  {
    question: '如何向我们反馈建议？',
    answer: '我们非常重视每一位用户的反馈！您可以通过页面底部的联系方式，或发送邮件至 contact@tangdou.com 向我们提出宝贵建议。每一条反馈我们都会认真阅读和改进。',
  },
];